export const scheduleHeaders = {
  employerCode: "EMPLOYER CODE",
  month: "For The Month Of",
  year: "Year Of Contribution",
  staffId: "Staff ID",
  rsapin: "RSA PIN",
  employeeName: "Name of Employee",
  normalContributionEmployee: "Normal contribution for employee",
  normalContributionEmployer: "Normal contribution for employer",
  voluntaryContributionEmployee: "Voluntary contribution by employee",
  voluntaryContributionEmployer: "Voluntary contribution by employer",
  otherContribution: "Other Contribution",
  contributionType: "Contribution Type/Code",
  total: "TOTAL AMT.(Naira)",
  pfaCode: "PFA code",
} as const;


export type ScheduleHeader = typeof scheduleHeaders[keyof typeof scheduleHeaders];

export const allHeaders = Object.values(scheduleHeaders);
